import { Icon, Tag } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const defaultProps = {
  iconType: 'user',
  classes: '',
  onClose: null,
  closable: false
};
const propTypes = {
  iconType: PropTypes.string,
  name: PropTypes.string.isRequired,
  classes: PropTypes.string,
  onClose: PropTypes.func,
  closable: PropTypes.bool
};

const UserTag = ({ iconType, name, onClose, classes, closable }) => (
  <Tag className={classes} onClose={onClose} closable={closable}>
    <Icon type={iconType} className="font-sm" />
    {name}
  </Tag>
);

UserTag.defaultProps = defaultProps;
UserTag.propTypes = propTypes;
export default UserTag;



// WEBPACK FOOTER //
// ./src/components/ui/Tags/UserTag.jsx